import React from 'react';
import Skeleton from '../../../../shared/components/ui/Skeleton/Skeleton';

const AnalyticsSkeleton = () => {
    return (
        <div className="analytics-page" style={{ padding: '2rem' }}>
            {/* Header Skeleton */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2.5rem' }}>
                <div>
                    <Skeleton variant="text" width={200} height={32} style={{ marginBottom: '8px' }} />
                    <Skeleton variant="text" width={300} height={16} />
                </div>
                <div style={{ display: 'flex', gap: '1rem' }}>
                    <Skeleton variant="rect" width={140} height={40} style={{ borderRadius: '10px' }} />
                    <Skeleton variant="rect" width={120} height={40} style={{ borderRadius: '10px' }} />
                </div>
            </div>

            {/* KPI Grid Skeleton */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem', marginBottom: '2.5rem' }}>
                {[...Array(4)].map((_, i) => (
                    <div key={i} style={{ background: 'white', padding: '1.5rem', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                        <Skeleton variant="text" width="40%" height={14} style={{ marginBottom: '1rem' }} />
                        <Skeleton variant="text" width="70%" height={28} style={{ marginBottom: '0.5rem' }} />
                        <Skeleton variant="text" width="30%" height={12} />
                    </div>
                ))}
            </div>

            {/* Charts Skeleton */}
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '1.5rem', marginBottom: '2.5rem' }}>
                <div style={{ background: 'white', padding: '2rem', borderRadius: '16px', border: '1px solid #e2e8f0', height: '400px' }}>
                    <Skeleton variant="text" width="20%" height={20} style={{ marginBottom: '2rem' }} />
                    <Skeleton variant="rect" width="100%" height={300} style={{ borderRadius: '8px' }} />
                </div>
                <div style={{ background: 'white', padding: '2rem', borderRadius: '16px', border: '1px solid #e2e8f0', height: '400px' }}>
                    <Skeleton variant="text" width="40%" height={20} style={{ marginBottom: '2rem' }} />
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '260px' }}>
                        <Skeleton variant="circle" width={200} height={200} />
                    </div>
                </div>
            </div>

            {/* Table Skeleton */}
            <div style={{ background: 'white', padding: '2rem', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                <Skeleton variant="text" width={180} height={20} style={{ marginBottom: '2rem' }} />
                {[...Array(5)].map((_, i) => (
                    <div key={i} style={{ display: 'flex', gap: '2rem', marginBottom: '1.5rem', paddingBottom: '1rem', borderBottom: '1px solid #f1f5f9' }}>
                        <Skeleton variant="circle" width={32} height={32} />
                        <Skeleton variant="text" width="30%" height={16} />
                        <Skeleton variant="text" width="20%" height={16} />
                        <Skeleton variant="text" width="20%" height={16} />
                        <Skeleton variant="text" width="10%" height={16} style={{ marginLeft: 'auto' }} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AnalyticsSkeleton;
